import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import { Celebration } from '../../uiKit/assets/svg/celebration.js'
import Feedback from '../../components/Feedback/feedback';

const AnonymousThankYou = ({ onClose }) => {

    const history = useHistory();

    const beMember = useSelector(state => state.donation.joinCommunity, shallowEqual);
    const name = useSelector(state => state.campaign.campaign.communityName, shallowEqual);

    const paymentInfo = useSelector(state => state.payment.paymentInfo, shallowEqual);

    const createAccountHandler = useCallback(() => history.push('/sign-up'), [history]);

    const loginHandler = useCallback(() => {
        if (!!paymentInfo.donorInfo.email) {
            history.push(`/login?email=${paymentInfo.donorInfo.email}`)
        } else {
            history.push(`/login`)
        }
    }, [history, paymentInfo.donorInfo.email]);


    if (!paymentInfo.clientSecret) history.push('/');

    if (!beMember) {
        return (
            <div className='createdPage'>
                {
                    paymentInfo.donorInfo.isVerified ? (
                        <Feedback
                            title="Thank you"
                            firstDescription='You have helped our community. Be proud.'
                            secondDescription="Log in for more."
                            button={{
                                feedbackTitle: "Log in",
                                feedbackAction: loginHandler,
                                disable: false
                            }}
                            Image={Celebration}
                            titleFontSize={24}
                        />
                    ) : (
                        <Feedback
                            title="Thank you"
                            firstDescription='You have helped our community. Be proud.'
                            secondDescription='Create account for future helping.'
                            button={{
                                feedbackTitle: 'Create account',
                                feedbackAction: createAccountHandler,
                                disable: false
                            }}
                            Image={Celebration}
                            titleFontSize={24}
                        />
                    )
                }
            </div>
        )
    }

    return (
        <div className='createdPage'>
            {
                paymentInfo.donorInfo.isVerified ? (
                    <Feedback
                        title="Thank you"
                        firstDescription="Thank you for supporting our community."
                        secondDescription='Please log in to check what is new.'
                        button={{
                            feedbackTitle: 'Log in',
                            feedbackAction: loginHandler,
                            disable: false
                        }}
                        Image={Celebration}
                        titleFontSize={24}
                    />
                ) : (
                    <Feedback
                        title="Thank you"
                        firstDescription={`We are glad that you decided to join our community ${name}.`}
                        secondDescription='The invitation has been sent to your email. Please check spam/junk folder if you cannot find it.'
                        button={{
                            feedbackTitle: 'Ok',
                            feedbackAction: onClose,
                            disable: false
                        }}
                        Image={Celebration}
                        titleFontSize={24}
                    />
                )
            }
        </div>
    )
}

export default AnonymousThankYou;